const services = [
  {
    title: "Space Planning",
    desc: "Optimize your layout with expert space planning tailored to your lifestyle and preferences.",
  },
  {
    title: "Color Selection",
    desc: "Get expert advice on selecting the best colors to complement your home's design.",
  },
  {
    title: "Material Selection",
    desc: "Choose the perfect materials guided by our experts ensuring quality and style harmony.",
  },
  {
    title: "Project Management",
    desc: "Stay stress-free as we coordinate and manage your project ensuring timely completion.",
  },
]

export function AdditionalServices() {
  return (
    <section className="border-t border-gray-200 py-20">
      <div className="mx-auto max-w-[1400px] px-8">
        <div className="reveal text-center">
          <p className="text-[11px] font-light tracking-[0.3em] text-gray-400 uppercase">
            Value Added
          </p>
          <h2 className="font-heading mt-3 text-[40px] leading-[1.15] text-navy sm:text-[48px]">
            ENHANCE YOUR EXPERIENCE
          </h2>
        </div>

        <div className="mt-14 grid gap-0 border border-gray-200 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((s, i) => (
            <div
              key={s.title}
              className={`reveal group p-8 transition-all duration-300 hover:bg-navy hover:text-white ${
                i < services.length - 1 ? "border-r border-gray-200" : ""
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="text-[11px] font-light tracking-[0.2em] text-gray-400 uppercase group-hover:text-white/50">
                0{i + 1}
              </span>
              <h4 className="font-heading mt-3 text-xl text-navy group-hover:text-white">
                {s.title}
              </h4>
              <p className="mt-3 text-[13px] font-light leading-relaxed text-gray-400 group-hover:text-white/70">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
